import React, { useContext } from 'react';
import { motion } from 'framer-motion';
import { FaChalkboardTeacher, FaLaptopCode, FaHandsHelping, FaUserGraduate } from 'react-icons/fa';
import Navbar from '../components/NavBar';
import Footer from '../components/Footer';
import { HeaderContext } from '../context/HeaderContext';

const About = () => {
  const { heroes, imageUrl } = useContext(HeaderContext);
  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />
      {/* Hero Section */}
      <section className="relative py-20 bg-gradient-to-r from-blue-600 to-indigo-700 text-white pt-52">
        <div className="container mx-auto px-4 text-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <h1 className="text-4xl md:text-5xl font-bold mb-6">আমার সম্পর্কে</h1>
            <p className="text-xl md:text-2xl max-w-2xl mx-auto">
              এককভাবে গুণগত প্রশিক্ষণ দিয়ে যাচ্ছি
            </p>
          </motion.div>
        </div>
      </section>

      {/* Personal Story */}
      <section className="py-16 container mx-auto px-4">
        <div className="flex flex-col lg:flex-row items-center gap-12">
          <motion.div 
            className="lg:w-1/3"
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
          >
            <div className="bg-white p-2 rounded-full shadow-xl inline-block">
              <div className="w-64 h-64 rounded-full bg-gray-200 overflow-hidden border-4 border-white">
                {/* আপনার ছবি যোগ করুন */}
              <div className="w-full h-full flex items-center justify-center text-gray-400">
                <img
                  src={`${imageUrl}/${heroes.image}`}
                  alt="Hero Image"
                  className="w-64 h-64 rounded-full object-cover"
                />
              </div>

              </div>
            </div>
          </motion.div>

          <motion.div 
            className="lg:w-2/3"
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
          >
            <h2 className="text-3xl font-bold text-gray-800 mb-6">আমার অনলাইন যাত্রার গল্প</h2>
            <div className="space-y-4 text-gray-600 text-lg">
              <p>
                ২০১৬ সালের কথা, যখন আমি একেবারে নতুন ছিলাম অনলাইনে। তখনও বুঝতে পারিনি যে এই পথটি কোথায় আমাকে নিয়ে যাবে। একদিন সরকার একটি ওয়েব ডিজাইন এবং ডেভেলপমেন্ট কোর্স চালু করেছিল। মনে হল, এটা আমার জীবনের সেরা সুযোগ। আমি ভর্তি হলাম, উত্তেজনায় ভরা ছিলাম। মনে হচ্ছিল, এবার বুঝি আমি সফল হবো। কিন্তু কিছুদিন পরই বুঝতে পারলাম, কোর্সটি সেই রকম কিছু শেখাচ্ছিল না যা আমি চাইছিলাম।
                আমার মেন্টর শুধু ফ্রন্টএন্ড শেখাচ্ছিলেন, আর ব্যাকএন্ড ডেভেলপমেন্টের দিকে কোনও ফোকাস ছিল না। আমি জানতাম যে, শুধুমাত্র ফ্রন্টএন্ড দিয়ে আমি কখনও আমার লক্ষ্য পূরণ করতে পারব না। তাই হতাশ হয়ে আমি সেই কোর্সটি ছেড়ে দিলাম।
              </p>
              <p>
               কিছুদিন চেষ্টা করেও আমি সফল হতে পারলাম না। তখনই আমি সিদ্ধান্ত নিলাম, আমি আরেকটা নতুন পথ খুঁজব। তখন আমি শুরু করলাম এফিলিয়েট মার্কেটিং এবং পরবর্তীতে সিপিএ মার্কেটিং। কিন্তু, জীবন থেমে থাকেনি। আমি নিজে একটি ICT কোচিং সেন্টার খুললাম, যেখানে আমি প্রজন্মকে ICT শেখাতাম। মনে হচ্ছিল, এবার সঠিক পথে আছি। কিন্তু করোনার কারণে ব্যবসা থমকে গেল। কোচিং সেন্টার বন্ধ হয়ে গেল। আমি হতাশ হয়ে পড়লাম, জীবন যেন একেবারে থেমে গেল।
              </p>
              <p>
                করোনা পরিস্থিতি আমার জন্য একটা বড় ধাক্কা ছিল। আর এই পরিস্থিতি আমার মাথার মধ্যে ভয়ের উদ্রেক করেছিল। মনে হচ্ছিল, হয়তো আমি কখনও ফিরে আসতে পারব না। একদিকে কোচিং সেন্টারের বন্ধ হওয়া, অন্যদিকে অনলাইনে কী করব, তাও বুঝতে পারছিলাম না। তখন একদিন, এক গভীর উপলব্ধি হলো— এটাই ছিল আমার জীবনের এপিফ্যানি।
                আমি বুঝলাম, জীবনে যখন সব কিছু ভেঙে যায়, তখনই প্রকৃত শিক্ষা পাওয়া যায়। তখনই একটা নতুন পথে হাঁটার সাহস পেলাম। আমি আবার শুরু করলাম কোডিং এবং ডিজিটাল মার্কেটিং শেখা।
              </p>
              <p>
                এবার আমি নিজের ওয়েবসাইট তৈরি করতে শুরু করলাম। এবং তৈরি করলাম একটি ই-কমার্স ওয়েবসাইট, যেখানে ছিল বিউটি প্রোডাক্টস। প্রথমে কিছুটা দ্বিধা ছিল, কিন্তু তারপর সহজেই একটি ফানেল ডিজাইন করে ফেললাম। কারণ, আমি জানতাম যে, আমি একজন ফুল স্ট্যাক ওয়েব ডেভেলপার। আমার দক্ষতা, যা আগে শিখেছিলাম, তা আমাকে নতুন কিছু করতে সাহায্য করেছিল।
                এটা ছিল আমার জন্য এক নতুন অর্জন, একটা নতুন শুরুর কথা। এর পরপরই আমি আরও ৫টি অনলাইন ব্যবসাকে সহায়তা করেছি। তাদের ব্যবসা ডিজিটাল মাধ্যমে গতি পেয়েছে, বেড়েছে লাভ। প্রতিটি সফলতা আমাকে নতুন কিছু শিখিয়েছে।   
              </p>
              <p>
                এখন, আমি একজন E-commerce Funnel Strategist। আমার কাজ হলো, একেকটি অনলাইন ব্যবসাকে তাদের ফানেল ডিজাইন এবং কাস্টমার যাত্রার মাধ্যমে সফল করে তোলা। আমি জানি, ফানেল ডিজাইন শুধুমাত্র ওয়েবসাইট তৈরির বিষয় নয়, এটা একটা প্রক্রিয়া যা কাস্টমারকে পুরো যাত্রায় পরিচালিত করে, তাদের জন্য অনুকূল সিদ্ধান্ত তৈরি করে দেয়।
              </p>
              <p>
               আজ আমি জানি, জীবন কখনোই সোজা পথের মতো না। জীবনে যেকোনো সময় আমরা পড়ে যেতে পারি, কিন্তু পড়ে যাওয়ার পর উঠে দাঁড়িয়ে আবার শুরু করার সাহসই আমাদের আসল শক্তি। আমার জীবনে যা ঘটেছে, তা এখন অন্যদেরও শিখাচ্ছি। আমি চাই, মানুষ জানুক— যখন জীবন আপনাকে নিচে ফেলে দেয়, তখনই আপনার সবচেয়ে বড় সুযোগ তৈরি হয়।

আমি আজ যেখানেই আছি, তার পেছনে সব সময় একটা শিক্ষা ছিল। আমি নিজের জীবনকে বদলানোর জন্য সংগ্রাম করেছি, এবং এখন অন্যদের সাহায্য করতে পারছি।
              </p>
            </div>
          </motion.div>
        </div>
      </section>

      {/* Teaching Approach */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <motion.div
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ duration: 0.6 }}
            className="text-center mb-12"
          >
            <h2 className="text-3xl font-bold text-gray-800 mb-4">আমার প্রশিক্ষণ পদ্ধতি</h2>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto">
              ব্যক্তিগত মনোযোগ ও ব্যবহারিক শিক্ষার উপর জোর দেওয়া হয়
            </p>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {[
              {
                icon: <FaChalkboardTeacher className="text-4xl text-blue-500" />,
                title: "একান্ত প্রশিক্ষণ",
                description: "ছোট গ্রুপে ব্যক্তিগত মনোযোগ দিয়ে প্রশিক্ষণ দেই"
              },
              {
                icon: <FaLaptopCode className="text-4xl text-green-500" />,
                title: "প্রজেক্ট ভিত্তিক",
                description: "রিয়েল ওয়ার্ল্ড প্রজেক্টের মাধ্যমে শেখানো"
              },
              {
                icon: <FaHandsHelping className="text-4xl text-yellow-500" />,
                title: "২৪/৭ সাপোর্ট",
                description: "যেকোনো প্রশ্নের জন্য সর্বদা উপলব্ধ"
              },
              {
                icon: <FaUserGraduate className="text-4xl text-purple-500" />,
                title: "ক্যারিয়ার গাইডেন্স",
                description: "চাকরি পাওয়া পর্যন্ত সহায়তা"
              }
            ].map((item, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.1 }}
                className="bg-gray-50 p-6 rounded-lg text-center hover:shadow-md transition-shadow"
              >
                <div className="flex justify-center mb-4">{item.icon}</div>
                <h3 className="text-xl font-bold mb-2">{item.title}</h3>
                <p className="text-gray-600">{item.description}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Student Success
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-4">
          <motion.div
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ duration: 0.6 }}
            className="text-center mb-12"
          >
            <h2 className="text-3xl font-bold text-gray-800 mb-4">আমার শিক্ষার্থীদের সাফল্য</h2>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto">
              যারা আমার কাছ থেকে প্রশিক্ষণ নিয়ে ভালো অবস্থানে আছেন
            </p>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {[
              {
                name: "রাকিব হাসান",
                position: "সফটওয়্যার ডেভেলপার, কোম্পানি X",
                testimonial: "স্যারের হাতে-কলমে শেখানোর পদ্ধতি আমার ক্যারিয়ার বদলে দিয়েছে"
              },
              {
                name: "তানজিনা আক্তার",
                position: "গ্রাফিক ডিজাইনার, কোম্পানি Y",
                testimonial: "একজন প্রশিক্ষক হিসাবে স্যারের ধৈর্য্য ও দক্ষতা অসাধারণ"
              },
              {
                name: "আরিফুল ইসলাম",
                position: "ফ্রিল্যান্সার, আপওয়ার্ক",
                testimonial: "প্রশিক্ষণ শেষে এখন মাসে $X আয় করছি"
              }
            ].map((student, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.1 }}
                className="bg-white p-6 rounded-lg shadow-sm"
              >
                <div className="flex items-center mb-4">
                  <div className="w-12 h-12 rounded-full bg-gray-200 mr-4 flex items-center justify-center">
                    <span className="text-xl">👤</span>
                  </div>
                  <div>
                    <h4 className="font-bold">{student.name}</h4>
                    <p className="text-sm text-gray-500">{student.position}</p>
                  </div>
                </div>
                <p className="text-gray-600 italic">"{student.testimonial}"</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section> */}

      {/* Call to Action
      <section className="py-16 bg-gradient-to-r from-blue-500 to-blue-600 text-white text-center">
        <div className="container mx-auto px-4">
          <motion.div
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ duration: 0.6 }}
          >
            <h2 className="text-3xl font-bold mb-6">আপনিও শুরু করতে প্রস্তুত?</h2>
            <p className="text-xl mb-8 max-w-2xl mx-auto">
              আজই আমার সাথে আপনার শেখার যাত্রা শুরু করুন
            </p>
            <button className="px-8 py-3 bg-white text-blue-600 rounded-lg font-bold hover:bg-gray-100 transition shadow-lg">
              কোর্সে এনরোল করুন
            </button>
          </motion.div>
        </div>
      </section> */}
      <Footer />
    </div>
  );
};

export default About;